import { render, staticRenderFns } from "./BankSidebarSection.vue?vue&type=template&id=77869c85&scoped=true&"
import script from "./BankSidebarSection.vue?vue&type=script&lang=js&"
export * from "./BankSidebarSection.vue?vue&type=script&lang=js&"
import style0 from "./BankSidebarSection.vue?vue&type=style&index=0&id=77869c85&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77869c85",
  null
  
)

export default component.exports